import { Link, usePhoneCampaign } from '@hc-frontend/core-ui';

export interface UnstyledPhoneLinkProps {
  includeTTY?: boolean;
}

/**
 * Renders a clickable phone link without any styling, for use in Builder in Unbounce-migrated pages
 */
export default function UnstyledPhoneLink(props: UnstyledPhoneLinkProps) {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return (
      <Link
        className="[all:inherit] cursor-pointer"
        id={phoneCampaign.href}
        href={phoneCampaign.href}
      >
        {props.includeTTY
          ? `${phoneCampaign.phoneNumber} (${phoneCampaign.tty})`
          : phoneCampaign.phoneNumber}
      </Link>
    );
  }
}
